import React from 'react'
import { useEffect as UseEffect, useState as UseState } from "react";
import auditService from '../../services/audit';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TypographyComponent from '../../components/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const index = ({ user, data, id }) => {

    const [auditView, setAuditView] = UseState([]);
    const [collapsedStatesAudit, setCollapsedStatesAudit] = UseState(false);

    UseEffect(() => {
        auditService.getAudit(user.client, user.data.instance, data.id, id).then((response) => {
            let arrayAuditView = [];
            for (let g = 0; g < response.data.length; g++) {
                let fechaHora = response.data[g].date.split('T');
                let fecha = fechaHora[0].split('-');
                let hora = fechaHora[1].split('.');
                response.data[g].date = `${fecha[2]}-${fecha[1]}-${fecha[0]} ${hora[0]}`
                arrayAuditView.push(response.data[g]);
            }
            setAuditView(arrayAuditView);
        }).catch((error) => {
            console.log(error);
        });

    }, []);

    const handleToggleCollapseAudit = () => {

        if (collapsedStatesAudit)
            setCollapsedStatesAudit(false)
        else
            setCollapsedStatesAudit(true);
    };

    return (
        <Box border={1} borderColor="rgb(0 0 0 / 13%)" borderRadius="4px" p={2} padding={1}>

            <Box display="flex" alignItems="center">
                <IconButton onClick={() => handleToggleCollapseAudit()}>
                    {collapsedStatesAudit ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                </IconButton>
                <TypographyComponent
                    paragraphType='body1'
                    text='Auditoría'
                />
            </Box>
            {collapsedStatesAudit && (
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {<Table>
                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                            <TableRow>
                                <TableCell>Contexto</TableCell>
                                <TableCell>Fecha</TableCell>
                                <TableCell>Campo</TableCell>
                                <TableCell>Modo</TableCell>
                                <TableCell>Valor Anterior</TableCell>
                                <TableCell>Valor Nuevo</TableCell>
                                <TableCell>Usuario</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {auditView.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.context}</TableCell>
                                    <TableCell>{item.date}</TableCell>
                                    <TableCell>{item.field}</TableCell>
                                    <TableCell>{item.mode}</TableCell>
                                    <TableCell>{item.oldValue}</TableCell>
                                    <TableCell>{item.newValue}</TableCell>
                                    <TableCell>{item.user}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>}
                </div>
            )}
        </Box>
    )
}

export default index;